/**
 * Kroner as the panel, the app and the accountant read them, from whole øre.  Moved here 2026-10-29 from expenses.js
 * and campaigns.js (two identical copies); both, and cash-gifts.js, re-export them, so their callers (and
 * apps/admin/src/core.ts) are unchanged.
 *
 *   formatKr(123450)                      → «1 234,50» (a no-break space between thousands, for screens)
 *   formatKr(123450, { grouped: false })  → «1234,50»  (the CSV: a number the accountant sums)
 *   formatKr(-500)                        → «-5,00»
 *   kr(123450)                            → «1 234,50 kr»
 *
 * Anything that is not a number counts as 0. The parsers (kroner() in expenses, campaigns and cash gifts) stay with
 * their modules: each has its own limits and its own message.
 *
 * Pure: no I/O.
 */
'use strict';

function formatKr(ore, { grouped = true } = {}) {
  const n = Number(ore) || 0;
  const sign = n < 0 ? '-' : '';
  const abs = Math.abs(n);
  const whole = String(Math.floor(abs / 100));
  const cents = String(abs % 100).padStart(2, '0');
  const grp = grouped ? whole.replace(/\B(?=(\d{3})+(?!\d))/g, '\u00a0') : whole;
  return `${sign}${grp},${cents}`;
}
const kr = (ore) => `${formatKr(ore)} kr`;

module.exports = { formatKr, kr };
